

import templateHomePage from '@/app-template/lib/pages/HomePage.vue';

export default {
  name: "HomePage",
  components: { templateHomePage },
};
